module.exports = function UpdateSourceDeregistrationRequest(cid) {
    this.cid = cid;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-deregistration-request.js
// module id = 492
// module chunks = 1